var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12V6C5.5 5.72386 5.72386 5.5 6 5.5Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5C8.77614 5.5 9 5.72386 9 6V12C9 12.2761 8.77614 12.5 8.5 12.5C8.22386 12.5 8 12.2761 8 12V6C8 5.72386 8.22386 5.5 8.5 5.5Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6C11.5 5.72386 11.2761 5.5 11 5.5C10.7239 5.5 10.5 5.72386 10.5 6V12C10.5 12.2761 10.7239 12.5 11 12.5C11.2761 12.5 11.5 12.2761 11.5 12V6Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15 3.55228 14.5523 4 14 4H13.5V13C13.5 14.1046 12.6046 15 11.5 15H5.5C4.39543 15 3.5 14.1046 3.5 13V4H3C2.44772 4 2 3.55228 2 3V2C2 1.44772 2.44772 1 3 1H6.5C6.5 0.447715 6.94772 0 7.5 0H9.5C10.0523 0 10.5 0.447715 10.5 1H14C14.5523 1 15 1.44772 15 2V3ZM4.61803 4L4.5 4.05902V13C4.5 13.5523 4.94772 14 5.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13V4.05902L12.382 4H4.61803ZM3 3H14V2H3V3Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.39ec008b541c7664d6fc275dcee6ed7d.svg";
export { ForwardRef as ReactComponent };